import React from "react";

import Form          from 'react-bootstrap/Form';
import Row           from 'react-bootstrap/Row';
import Col           from 'react-bootstrap/Col';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

const Etapa3 = ( props ) => {

  return (
    <Row>
      <Col md={{ span: 6, offset: 3 }} className="zzbox">

        <Row>
          <Col md={7}>
            <FloatingLabel
              controlId = "produto_id"
              label     = "Produto">
              <Form.Select  value     = {props.values.produto_id} 
                            onChange  = {props.handleChange} 
                            name      = "produto_id">
                { props.tblProdutos.map( (row, index ) => (
                  <option key={index} value={row.id}>{row.nome}</option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col md={5}>
            <FloatingLabel
              controlId = "doses"
              label     = "Volume *">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.doses}
                            onChange    = {props.handleChange} 
                            name        = "doses"/>
            </FloatingLabel>
          </Col>
        </Row>

        <br/>

        <Form.Check type     = "checkbox"
                    onChange = {props.handleChange}                    
                    label    = "Incluir serviços para aplicação de vacina ou coleta de testes"
                    name     = "aplicacao"/>

        <br/>

        <Row>
          <Col><h5>Se possível, anexe uma planilha com as localidades</h5></Col>
        </Row>

        <Row>
          <Col>
            <Form.Control type     = "file"
                          size     = "sm"
                          onChange = {props.handleChange}
                          name     = "selectedFile"/>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col>
            <FloatingLabel
              controlId = "obs"
              label     = "Observações">
              <Form.Control as          = "textarea" 
                            rows        = {4} 
                            placeholder = "."
                            value       = {props.values.obs} 
                            onChange    = {props.handleChange} 
                            name        = "obs"/>
            </FloatingLabel>
          </Col>
        </Row>

        { /*
    <div className="row">
      <div className="col-md-12 text-center">
        <h5>Marque abaixo os estados que possuem filiais<br/>que irão participar da campanha</h5>
      </div>
    </div>

    <br/>

    <div className="row">
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;São Paulo-SP</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Rio de Janeiro-RJ</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Acre-AC</label>
      </div>
    </div>


    <div className="row">
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Alagoas-AL</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Amapá-AP</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Amazonas-AM</label>
      </div>
    </div>
        
        
    <div className="row">
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Bahia-BA</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Ceará-CE</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Distrito Federal-DF</label>
      </div>
    </div>


    <div className="row">
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Espírito Santo-ES</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Goiás-GO</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Maranhão-MA</label>
      </div>
    </div>
        
        
    <div className="row">
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Mato Grosso-MT</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Mato Grosso do Sul-MS</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Minas Gerais-MG</label>
      </div>
    </div>


    <div className="row">
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Pará-PA</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Paraíba-PB</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Paraná-PR</label>
      </div>
    </div>
        
        
    <div className="row">
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Pernambuco-PE</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Piauí-PI</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Rio Grande do Norte-RN</label>
      </div>
    </div>

        
    <div className="row">
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Rio Grande do Sul-RS</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Rondônia-RO</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Roraima-RR</label>
      </div>
    </div>
        
        
    <div className="row">
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Santa Catarina-SC</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Sergipe-SE</label>
      </div>
      <div className="col-md-4">
        <input className="frmSP" type="checkbox" value="" id="frmSP"/>
        <label className="form-check-label" htmlFor="frmSP">&nbsp;Tocantins-TO</label>
      </div>
    </div>

    <br/>
    */ }

      </Col>
    </Row>
  );
}
export default Etapa3;